import React from 'react';
import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// Style
const useStyles = makeStyles((theme) => ({
  btn_enabled: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    border: `2px solid ${theme.palette.primary.main}`,
    marginLeft: 12,
  },
  btn_disabled: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    marginLeft: 12,
    border: '2px solid #e0e0e0',
  },
}));

// Component
function AmberPrimaryButton(props) {
  const { onClick, text, disabled, ...rest } = props;
  const classes = useStyles();

  function getClassNameByStatus() {
    if (disabled) {
      return classes.btn_disabled;
    }

    return classes.btn_enabled;
  }

  return (
    <Button
      variant="contained"
      onClick={onClick}
      color="primary"
      className={getClassNameByStatus()}
      disabled={disabled}
      {...rest}
    >
      <Box
        component="span"
        fontSize={14}
        fontWeight={600}
        color="white"
        paddingLeft={1}
        paddingRight={1}
      >
        {text}
      </Box>
    </Button>
  );
}

AmberPrimaryButton.propTypes = {
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
AmberPrimaryButton.defaultProps = {
  disabled: false,
};

export default AmberPrimaryButton;
